"use client";

import React, { useState } from "react";

interface NavCard {
  id: string;
  label: string;
  description: string;
  icon: React.ReactNode;
  accentColor: string;
  bgColor: string;
  iconBg: string;
}

const ALL_NAV_CARDS: NavCard[] = [
  {
    id: "best-offers",
    label: "Best Offers",
    description: "Handpicked deals just for you",
    accentColor: "#F97316",
    bgColor: "#FFF7ED",
    iconBg: "#FFEDD5",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" aria-hidden="true">
        <path fillRule="evenodd" d="M9.315 7.584C12.195 3.883 16.695 1.5 21.75 1.5a.75.75 0 01.75.75c0 5.056-2.383 9.555-6.084 12.436A6.75 6.75 0 019.75 22.5a.75.75 0 01-.75-.75v-4.131A15.838 15.838 0 016.382 15H2.25a.75.75 0 01-.75-.75 6.75 6.75 0 017.815-6.666zM15 6.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z" clipRule="evenodd" />
        <path d="M5.26 17.242a.75.75 0 10-.897-1.203 5.243 5.243 0 00-2.05 5.022.75.75 0 00.625.627 5.243 5.243 0 005.022-2.051.75.75 0 10-1.202-.897 3.744 3.744 0 01-3.008 1.51c0-1.23.592-2.323 1.51-3.008z" />
      </svg>
    ),
  },
  {
    id: "savings-coupons",
    label: "Savings & Coupons",
    description: "Exclusive codes & discounts",
    accentColor: "#DC2626",
    bgColor: "#FEE2E2",
    iconBg: "#FEE2E2",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" aria-hidden="true">
        <path fillRule="evenodd" d="M1.5 6.375c0-1.036.84-1.875 1.875-1.875h17.25c1.035 0 1.875.84 1.875 1.875v3.026a.75.75 0 01-.375.65 2.249 2.249 0 000 3.898.75.75 0 01.375.65v3.026c0 1.035-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 011.5 17.625v-3.026a.75.75 0 01.374-.65 2.249 2.249 0 000-3.898.75.75 0 01-.374-.65V6.375zm15-1.125a.75.75 0 01.75.75v.75a.75.75 0 01-1.5 0V6a.75.75 0 01.75-.75zm.75 4.5a.75.75 0 00-1.5 0v.75a.75.75 0 001.5 0v-.75zm-.75 3a.75.75 0 01.75.75v.75a.75.75 0 01-1.5 0v-.75a.75.75 0 01.75-.75zm.75 4.5a.75.75 0 00-1.5 0V18a.75.75 0 001.5 0v-.75zM6 12a.75.75 0 01.75-.75H12a.75.75 0 010 1.5H6.75A.75.75 0 016 12zm.75 2.25a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3z" clipRule="evenodd" />
      </svg>
    ),
  },
  {
    id: "trending-products",
    label: "Trending Products",
    description: "What's hot right now",
    accentColor: "#1E3A5F",
    bgColor: "#F8FAFC",
    iconBg: "#F8FAFC",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" aria-hidden="true">
        <path fillRule="evenodd" d="M15.22 6.268a.75.75 0 01.968-.431l5.942 2.28a.75.75 0 01.431.97l-2.28 5.94a.75.75 0 11-1.4-.537l1.63-4.251-1.086.484a11.2 11.2 0 00-5.45 5.173.75.75 0 01-1.199.19L9 12.31l-6.22 6.22a.75.75 0 11-1.06-1.06l6.75-6.75a.75.75 0 011.06 0l3.606 3.606a12.695 12.695 0 015.68-4.973l1.086-.484-4.251-1.631a.75.75 0 01-.432-.97z" clipRule="evenodd" />
      </svg>
    ),
  },
  {
    id: "branded-products",
    label: "Branded Products",
    description: "Top brands, best prices",
    accentColor: "#1E3A5F",
    bgColor: "#F8FAFC",
    iconBg: "#F8FAFC",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" aria-hidden="true">
        <path d="M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 01-.383-.218 25.18 25.18 0 01-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0112 5.052 5.5 5.5 0 0116.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 01-4.244 3.17 15.247 15.247 0 01-.383.219l-.022.012-.007.004-.003.001a.752.752 0 01-.704 0l-.003-.001z" />
      </svg>
    ),
  },
];

interface Props {
  showBestOffers: boolean;
  showSavingsCoupons: boolean;
  showTrendingProducts: boolean;
  showBrandedProducts: boolean;
}

const HomeSectionNavigator = ({
  showBestOffers,
  showSavingsCoupons,
  showTrendingProducts,
  showBrandedProducts,
}: Props) => {
  const [activeId, setActiveId] = useState<string | null>(null);

  const visibilityMap: Record<string, boolean> = {
    "best-offers": showBestOffers,
    "savings-coupons": showSavingsCoupons,
    "trending-products": showTrendingProducts,
    "branded-products": showBrandedProducts,
  };

  const visibleCards = ALL_NAV_CARDS.filter((card) => visibilityMap[card.id]);

  if (visibleCards.length === 0) return null;

  const handleScrollTo = (id: string) => {
    setActiveId(id);
    const el = document.getElementById(id);
    if (el) {
      const offset = 80;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  // Responsive grid: always fill columns based on count
  const gridCols =
    visibleCards.length === 1
      ? "grid-cols-1"
      : visibleCards.length === 2
        ? "grid-cols-2"
        : visibleCards.length === 3
          ? "grid-cols-2 md:grid-cols-3"
          : "grid-cols-2 md:grid-cols-4";

  return (
    <section
      aria-label="Homepage Section Navigator"
      className="w-full bg-white border-y border-[#E5E7EB] py-5"
    >
      <div className="container mx-auto px-6 sm:px-8">
        {/* Cards */}
        <div className={`grid ${gridCols} gap-3`}>
          {visibleCards.map((card) => {
            const isActive = activeId === card.id;
            return (
              <button
                key={card.id}
                onClick={() => handleScrollTo(card.id)}
                aria-label={`Navigate to ${card.label} section`}
                className={`group relative flex items-center gap-3 px-4 py-3.5 rounded-xl border transition-all duration-200 cursor-pointer text-left w-full
                  ${isActive ? "border-[#F97316] shadow-md" : "border-[#E5E7EB] hover:border-[#F97316]/40 hover:shadow-md"}
                  bg-white`}
                style={isActive ? { boxShadow: `0 4px 16px -4px ${card.accentColor}33` } : {}}
              >
                {/* Icon */}
                <span
                  className="flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-200"
                  style={{ backgroundColor: isActive ? card.bgColor : card.iconBg, color: card.accentColor }}
                >
                  {card.icon}
                </span>

                {/* Text */}
                <span className="flex flex-col min-w-0">
                  <span
                    className="text-[13px] font-bold leading-snug truncate transition-colors duration-200"
                    style={{ color: isActive ? card.accentColor : "#111827" }}
                  >
                    {card.label}
                  </span>
                  <span className="text-[11px] text-[#4B5563] leading-tight truncate">
                    {card.description}
                  </span>
                </span>

                {/* Active indicator dot */}
                {isActive && (
                  <span
                    className="absolute top-2.5 right-2.5 w-1.5 h-1.5 rounded-full"
                    style={{ backgroundColor: card.accentColor }}
                    aria-hidden="true"
                  />
                )}

                {/* Hover arrow */}
                <span
                  className="absolute right-3 bottom-3 opacity-0 group-hover:opacity-100 transition-all duration-200 translate-x-0 group-hover:translate-x-0.5"
                  style={{ color: card.accentColor }}
                  aria-hidden="true"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-3 h-3">
                    <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z" clipRule="evenodd" />
                  </svg>
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HomeSectionNavigator;
